import React, { useCallback, useEffect } from 'react'
import { useBlocker } from 'react-router'
import { ExclamationCircleFilled } from '@ant-design/icons'
import { Modal } from 'antd'
import { useTranslation } from 'react-i18next'

const { confirm } = Modal

const useExchangeRateBlocker = (hasModifications: boolean) => {
  const { t } = useTranslation()

  // block navigating elsewhere when there are unsaved changes
  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) => hasModifications && currentLocation.pathname !== nextLocation.pathname
  )

  const showConfirm = useCallback(() => {
    if (blocker.state === 'blocked') {
      confirm({
        icon: <ExclamationCircleFilled />,
        title: t('confirmation:navigateUnsaved:title', 'Huomio'),
        content: t(
          'confirmation:navigateUnsaved:content',
          'Sinulla on tallentamattomia muutoksia. Haluatko jatkaa tallentamatta?'
        ),
        okText: t('global:yes', 'Kyllä'),
        cancelText: t('global:no', 'Ei'),
        onOk() {
          blocker.proceed()
        },
        onCancel() {
          blocker?.reset()
        }
      })
    }
  }, [blocker, t])

  useEffect(showConfirm, [showConfirm])
}

export default useExchangeRateBlocker
